// fetch
import { getClaimFileTypes, getClaimFiles, postClaimFiles, deleteClaimFile, putClaimFile } from 'src/fetch/claims';
import {
  getDriverFileTypes, getDriverFiles, postDriverFiles, deleteDriverFile, putDriverFile,
} from 'src/fetch/drivers';
import { getInsuranceDocumentTypes, getPolicyFiles, postPolicyFiles } from 'src/fetch/risk/insurance';
import {
  getRepairOrderDocumentTypes, getRepairOrderFiles, postRepairOrderFiles, deleteRepairOrderFile,
  updateRepairOrderFileInfo,
} from 'src/fetch/repairOrders';
import {
  getOrderDocumentTypes,
  getOrderFiles,
  postOrderFiles,
  updateOrderFileInfo,
  deleteOrderFile,
  getMasterOrderDocumentTypes,
} from 'src/fetch/orders';
import {
  getOrganisationFileTypes, getOrganizationFiles, postOrganizationFiles, deleteOrganizationFile,
} from 'src/fetch/organizations';
import {
  getOwnerFileTypes, getOwnerFiles, postOwnerFiles, deleteOwnerFile, putOwnerFile,
} from 'src/fetch/owners';
import {
  getPerDiemFileTypes, getPerDiemFiles, postPerDiemFiles, deletePerDiemFile,
} from 'src/fetch/perDiem';
import {
  getQuoteDocumentTypes, getQuoteFiles, postQuoteFiles, updateQuoteFileInfo, deleteQuoteFile,
} from 'src/fetch/pricing';
import {
  getLoanDocumentTypes, getLoanFiles, postLoanFiles, updateTruckLoanFileInfo, deleteLoanFile, getTruckFileTypes, getTruckFiles, postTruckFiles, deleteTruckFile, putTruckFile,
  getTruckPermitRuleFiles,
  postTruckPermitRuleFiles,
  deleteTruckPermitRuleFile,
  putTruckPermitRuleFiles,
} from 'src/fetch/trucks';

const TRUCK_PERMIT_DOCUMENT_TYPE = -106;

/**
 * source config:
 * {
 *    name: 'drivers', required
 *    getFiles: func, required
 *    postFiles: func, required
 *    deleteFile: func,
 *    putFile: func,
 *    getDocumentTypes: func, required
 * }
 */

const config = {
  sources: [
    {
      name: 'claim',
      getFiles: getClaimFiles,
      postFiles: postClaimFiles,
      deleteFile: deleteClaimFile,
      putFile: putClaimFile,
      getDocumentTypes: getClaimFileTypes,
    },
    {
      name: 'driver',
      getFiles: getDriverFiles,
      postFiles: postDriverFiles,
      deleteFile: deleteDriverFile,
      putFile: putDriverFile,
      getDocumentTypes: getDriverFileTypes,
    },
    {
      name: 'insurance',
      getFiles: getPolicyFiles,
      postFiles: postPolicyFiles,
      getDocumentTypes: getInsuranceDocumentTypes,
    },
    {
      name: 'order',
      getFiles: getOrderFiles,
      postFiles: postOrderFiles,
      deleteFile: deleteOrderFile,
      putFile: updateOrderFileInfo,
      getDocumentTypes: getOrderDocumentTypes,
    },
    {
      name: 'organization',
      getFiles: getOrganizationFiles,
      postFiles: postOrganizationFiles,
      deleteFile: deleteOrganizationFile,
      getDocumentTypes: getOrganisationFileTypes,
    },
    {
      name: 'owner',
      getFiles: getOwnerFiles,
      postFiles: postOwnerFiles,
      deleteFile: deleteOwnerFile,
      putFile: putOwnerFile,
      getDocumentTypes: getOwnerFileTypes,
    },
    {
      name: 'perDiemContractRules',
      getFiles: getPerDiemFiles,
      postFiles: postPerDiemFiles,
      deleteFile: deletePerDiemFile,
      getDocumentTypes: getPerDiemFileTypes,
    },
    {
      name: 'quote',
      getFiles: getQuoteFiles,
      postFiles: postQuoteFiles,
      deleteFile: deleteQuoteFile,
      putFile: updateQuoteFileInfo,
      getDocumentTypes: getQuoteDocumentTypes,
    },
    {
      name: 'repairOrder',
      getFiles: getRepairOrderFiles,
      postFiles: postRepairOrderFiles,
      putFile: updateRepairOrderFileInfo,
      deleteFile: deleteRepairOrderFile,
      getDocumentTypes: getRepairOrderDocumentTypes,
    },
    {
      name: 'truck',
      getFiles: getTruckFiles,
      postFiles: postTruckFiles,
      deleteFile: deleteTruckFile,
      putFile: putTruckFile,
      getDocumentTypes: getTruckFileTypes,
    },
    {
      name: 'truckPermitRule',
      getFiles: getTruckPermitRuleFiles,
      postFiles: postTruckPermitRuleFiles,
      deleteFile: deleteTruckPermitRuleFile,
      putFile: putTruckPermitRuleFiles,
      getDocumentTypes: () => new Promise((r) => r([{ id: TRUCK_PERMIT_DOCUMENT_TYPE, name: 'Truck Permit Rule' }])),
    },
    {
      name: 'truckLoan',
      getFiles: getLoanFiles,
      postFiles: postLoanFiles,
      deleteFile: deleteLoanFile,
      putFile: updateTruckLoanFileInfo,
      getDocumentTypes: getLoanDocumentTypes,
    },
    {
      name: 'masterOrder',
      getFiles: async () => {},
      postFiles: async () => {},
      deleteFile: async () => {},
      putFile: async () => {},
      getDocumentTypes: getMasterOrderDocumentTypes,
    },
  ],
};

export const getSourceConfig = (name) => config.sources.find((item) => item.name === name);

export default config;
